import { createAction, props } from '@ngrx/store';
import { ICustomerData, ICustomerModel } from '@partners/api';

export class CustomerActions {
  static reset = createAction('[Customer] Reset State');
  static load = createAction('[Customer] Load');
  static loadSuccess = createAction('[Customer] Load Success', props<{ model: ICustomerModel; data: ICustomerData }>());
  static loadFailure = createAction('[Customer] Load Failure', props<{ error: any }>());
}
